import ConditionalRender from '@/components/common/ConditionalRender';
import DefaultButton from '@/components/common/default/DefaultButton';
import LoadingComponent from '@/components/common/LoadingComponent';
import useEvents from '@/hooks/useEvents';
import useTypedTranslation from '@/hooks/useTypedTranslation';
import { SkuSellNowProps } from '@/types/props/components/skus';
import { SkuEnum } from '@/types/translations/SkuEnum';
import event from '@/utilites/gTag';
import { toDe } from '@/utilites/sku-operations';
import clsx from 'clsx';
import { useRouter } from 'next/router';
import { FaChevronRight } from 'react-icons/fa';

export default function SkuSellNow({
  skuSlug,
  highestBid,
  spiritoryBottle,
  isAdmin,
  bidsAskLoading,
  skuName,
  skuCategoryName,
}: SkuSellNowProps) {
  const router = useRouter();
  const { translate } = useTypedTranslation<SkuEnum>('sku');
  const { fireSellNowButtonClickEvent } = useEvents('', []);

  const handleClickSellNow = () => {
    fireSellNowButtonClickEvent({
      slug: skuSlug,
      product_name: skuName,
      product_category: skuCategoryName,
      product_price: highestBid || 0,
      page_type: 'product',
    });
    router.push(
      clsx({
        [`/${skuSlug}/sell?sell=true`]: highestBid,
        [`/${skuSlug}/sell`]: !highestBid,
      })
    );
  };
  return (
    <LoadingComponent
      as="div"
      componentProps={{
        className: 'tw-contents',
      }}
      loading={bidsAskLoading}
    >
      <div className="tw-flex tw-items-center tw-justify-center tw-py-7">
        <ConditionalRender condition={(spiritoryBottle && isAdmin) || !spiritoryBottle}>
          <p className={`tw-mb-0 tw-font-semibold max-nine:tw-hidden`}>
            {' '}
            {translate(SkuEnum.for_sellers)}: &nbsp;&nbsp;&nbsp;
          </p>

          <DefaultButton
            onClick={handleClickSellNow}
            className="!tw-max-w-xl tw-rounded-xl tw-border tw-border-solid tw-border-customCardGray tw-bg-white tw-px-5 tw-py-2 tw-font-semibold tw-text-gray-700 tw-shadow-md tw-transition tw-duration-300 tw-ease-in-out hover:tw-border-main-shades-300 hover:tw-bg-main-shades-100 hover:tw-text-gray-900 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-main-shades-300 focus:tw-ring-offset-2 active:tw-scale-95 disabled:tw-cursor-not-allowed disabled:tw-opacity-50 max-nine:tw-w-full"
          >
            <span className={`tw-flex tw-items-center tw-justify-center tw-gap-3 tw-py-1`}>
              {highestBid
                ? translate(SkuEnum.sell_now_for_x_or_ask_for_more).replace(
                    '{price}',
                    toDe(highestBid, { withDigits: false })
                  )
                : translate(SkuEnum['sell.sell_now'])}{' '}
              <FaChevronRight className="tw-text-sx tw-font-semibold" />
            </span>
          </DefaultButton>
        </ConditionalRender>
      </div>
    </LoadingComponent>
  );
}
